import { useRouter } from "next/router";
import Link from "next/link";
import { useTranslation } from "react-i18next";
// import { useState } from "react";

import { ROUTE } from "@/route/app_routes.js";





const Nav = () => {

  // create router monitor, to be used to control "isActive" states of the nav links
  const router = useRouter();
  const isActive = (href) => router.pathname.startsWith(href);
  const { t } = useTranslation();


  return (
    <nav className="mainmenu-nav">
      <ul className="mainmenu">

        {/* <li className="with-megamenu has-menu-child-item position-static">
          <Link className={`${activeMenuItem === "home" ? "open" : ""} ${activeMenuItem === "home" ? "active d-block" : ""}`}
            onClick={() => toggleMenuItem("home")} href={ROUTE.home}>Home</Link>
        </li> */}

        <li className="with-megamenu has-menu-child-item position-static">
          <Link className={`${isActive(ROUTE.events) ? "active d-block" : ""}`} href={ROUTE.events}>{t("nav.allEvents")}</Link>
        </li>

      </ul>
    </nav>
  );
};


export default Nav;
